import $ from "jquery";
const articleFilter = () => {
  const init = () => {
    filter();
  };

  const filter = () => {
    const el = {
      article: "#ArticleFilter",
      list: ".ArticleFilterList",
      btnApply: "#ArticlesBtnApply",
      btnReset: "#ArticlesBtnReset",
    };

    if ($(el.article).length === 0) return;

    let isFilterOpen = false;

    $(document).on("click", el.article, function (e) {
      e.stopPropagation(); // Prevent the event from bubbling up to the document
      $(el.list).fadeToggle();
      isFilterOpen = !isFilterOpen;
    });

    $(document).on("click", function (e) {
      // Close the filter if it's open and the user clicks outside the filter
      if (
        isFilterOpen &&
        !$(e.target).closest(el.article).length &&
        !$(e.target).closest(el.list).length
      ) {
        $(el.list).fadeOut();
        isFilterOpen = false;
      }
    });

    // Apply filter button click handler
    $(document).on("click", el.btnApply, function () {
      const $btn = $(this);
      $btn.attr("disabled", true);
      const $spinner = $btn.find(".spinner");
      $spinner.removeClass("hidden");

      const selectedFilters = [];

      // Collect selected filters
      $(".ArticleFilterList input:checked").each(function () {
        selectedFilters.push($(this).val());
      });

      // Update the URL with query parameters
      const queryParams = new URLSearchParams();
      queryParams.set("page", "1");
      if (selectedFilters.length > 0) {
        queryParams.set("post_category", selectedFilters.join(","));
      } else {
        queryParams.delete("post_category");
      }
      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

      window.location.href = newUrl;
    });

    // Reset filter button click handler
    $(document).on("click", el.btnReset, function () {
      const $btn = $(this);
      $btn.attr("disabled", true);
      const $spinner = $btn.find(".spinner");
      $spinner.removeClass("hidden");

      // Uncheck all checkboxes
      $(".ArticleFilterList input:checked").prop("checked", false);

      // Remove the post_category query parameter from the URL
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete("post_category");
      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.location.href = newUrl;
    });
  };

  init();
};

try {
  articleFilter();
} catch (e) {
  console.error("Article Filter : ", e);
}
